const consentModeList = ['QUERY', 'VIEW', 'STORE', 'STREAM'];

export default consentModeList;
